module.exports = __webpack_public_path__ + "media/חום.7339a4a7.mp3";